export const j2h_rules_en = [
  "Find out your hometown and return there with others from the same place.",
  "Each player is secretly assigned a hometown at the start of the game, which they do not know.",
  "In each round, players must choose an area to move to. However, Players can't select the same area they are currently in. If player does not make a choice, a random available area will be selected.",
  "Each round is composed of two distinct phases: the 'Square' phase and the 'Area' phase.",
  "During the 'Square' phase, all players gather and decide their next destination.",
  "During the 'Area' phase, players are shown how many people are in each area and how many are in their own home area. During this phase, players can only communicate with those in the same area.",
  "There are 4 areas (or 3, excluding the city, depending on the number of players).",
  "number of players in the area",
  "number of players in their hometown",
  "If, during the 'Area' phase, all players who share the same home area are gathered in that area, they win the game.",
  // Page 4: Strategy & Example
  "Strategy Tips",
  "Pay attention to how other players move and vote - they might be looking for their hometown",
  "Use communication strategically during area phases to gather information",
  "Don't reveal your hometown too early, but give subtle hints to potential teammates",
  "Once you have found all your hometown members, you must arrive at your hometown together in the same round to win. Plan your final move with your teammates and move at the same time. If even one person arrives late, you cannot win.",
  "To arrive together: All teammates must be in a non-hometown area for one round, so that everyone can move into the hometown together in the next turn. If even one person stays in the hometown, you cannot all arrive at the same time.",
  "Example Game (4 players)",
  "Players A, B assigned to Sky / Players C, D assigned to Forest",
  "Round 1: All players start in Square → move to different areas",
  "Area phase: Check numbers and communicate with players in same area",
  "Continue until Sky players meet in Sky area or Forest players meet in Forest area",
];

export const j2h_rules_ko = [
  "자신의 고향을 알아내고, 자신과 같은 고향의 사람들과 함께 고향에 돌아가야 합니다.",
  "게임 시작 시, 각 플레이어는 고향을 비밀리에 배정받으며 본인을 포함하여 누구도 알 수 없습니다.",
  "매 라운드마다 플레이어는 이동할 지역을 선택해야 합니다. 단, 현재 위치한 지역으로는 이동할 수 없습니다. 만약 플레이어가 선택하지 않으면, 무작위로 이동 가능한 지역 중 하나가 선택됩니다.",
  "매 라운드는 '광장' 단계와 '지역' 단계, 두 단계로 진행됩니다.",
  "'광장' 단계에서는 모든 플레이어가 한자리에 모이고 다음 목적지를 선택합니다.",
  "'지역' 단계에서는 각 지역에 몇 명이 있는지, 그리고 몇 명이 자신의 고향에 있는지 알 수 있습니다. 이 단계에서는 같은 지역에 있는 사람들과만 소통할 수 있습니다.",
  "다음 4개 (인원에 따라 도시를 제외한 3개)의 지역이 존재합니다.",
  "지역에 있는 플레이어 수",
  "고향에 있는 플레이어 수",
  "'지역' 단계에서 특정 지역에 해당 지역을 고향으로 가진 모든 플레이어가 모일 경우, 해당 플레이어들이 승리합니다.",
  // Page 4: 전략 & 예시
  "전략 팁",
  "다른 플레이어들의 이동 패턴과 투표를 주의 깊게 관찰하세요 - 그들이 자신의 고향을 찾고 있을 수 있습니다",
  "지역 단계에서 전략적으로 소통하여 정보를 수집하세요",
  "너무 일찍 고향을 드러내지 말되, 잠재적 팀원에게는 미묘한 힌트를 주세요",
  "모든 고향원을 찾았다면 반드시 같은 라운드에 함께 고향에 도착해야 합니다. 마지막 이동은 팀원들과 전략적으로 상의하여 동시에 이동하세요. 한 명이라도 늦게 도착하면 승리할 수 없습니다.",
  "동시에 도착하려면: 한 라운드 동안 모든 인원이 고향이 아닌 다른 지역에 모여 있어야, 그 다음 라운드에 모두 함께 고향으로 이동할 수 있습니다. 한 명이라도 고향에 남아 있으면 동시에 도착할 수 없습니다.",
  "게임 예시 (4명)",
  "플레이어 A, B는 하늘 고향 / 플레이어 C, D는 숲 고향",
  "1라운드: 모든 플레이어가 광장에서 시작 → 각자 다른 지역으로 이동",
  "지역 단계: 숫자를 확인하고 같은 지역의 플레이어들과 소통",
  "하늘 플레이어들이 하늘에서 만나거나 숲 플레이어들이 숲에서 만날 때까지 계속",
];
